import { render, staticRenderFns } from "./NuevaListaPrecio.vue?vue&type=template&id=61dcbca2"
import script from "./NuevaListaPrecio.vue?vue&type=script&lang=js"
export * from "./NuevaListaPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports